import React from "react";
import { useNavigate } from "react-router-dom";
import "./DynamicButton.css";

/**
 * Reusable SaaS-ready dynamic button
 */
const DynamicButton = ({
  text = "",
  icon = "fa-plus",
  size = "md",
  variant = "primary",
  link = "",
  onClick,
  disabled = false,
  title = "",
  ariaLabel = "",

  // ✅ customization props
  bgColor,
  textColor,
  hoverBgColor,
  hoverTextColor,
  outlineColor,
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (disabled) return;
    if (link) navigate(link);
    if (onClick) onClick(e);
  };

  // build inline styles (only add if defined)
  const customStyle = {};
  if (bgColor) customStyle.backgroundColor = bgColor;
  if (textColor) customStyle.color = textColor;
  if (outlineColor) customStyle.borderColor = outlineColor;
  if (hoverBgColor) customStyle["--hover-bg"] = hoverBgColor;
  if (hoverTextColor) customStyle["--hover-text"] = hoverTextColor;

  return (
    <button
      className={`dynamic-btn ${size} ${variant} ${disabled ? "disabled" : ""}`}
      onClick={handleClick}
      disabled={disabled}
      title={title || text}
      aria-label={ariaLabel || title || text || icon}
      style={customStyle}
    >
      {icon && (
        <i
          className={`fas ${icon}`}
          style={{ marginRight: text ? 8 : 0 }}
          aria-hidden="true"
        />
      )}
      {text && <span>{text}</span>}
    </button>
  );
};

export default DynamicButton;
